<template>
<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.28906 19.1816H14.7236C15.1895 19.1816 15.5498 18.8213 15.5498 18.3555C15.5498 17.96 15.2773 17.6699 14.9434 17.5117C13.8623 17.0283 13.6514 15.5342 14.75 14.4883C15.1982 14.0928 15.541 13.6533 15.541 12.7656V3.03613C15.541 1.1377 14.5654 0.144531 12.6758 0.144531H3.30664C1.42578 0.144531 0.441406 1.12891 0.441406 3.03613V16.3164C0.441406 18.1973 1.42578 19.1816 3.28906 19.1816ZM12.5176 1.89355C13.3701 1.89355 13.792 2.3418 13.792 3.15039V12.4932C13.792 12.9238 13.5459 13.1611 13.1064 13.1611H4.47559V1.89355H12.5176ZM2.19043 13.4688V3.15039C2.19043 2.4209 2.5332 1.99023 3.22754 1.91113V13.1699C2.83203 13.2051 2.48926 13.3105 2.19043 13.4688ZM6.04883 5.91895H12.1924C12.5352 5.91895 12.8164 5.6377 12.8164 5.29492C12.8164 4.95215 12.5352 4.6709 12.1924 4.6709H6.04883C5.70605 4.6709 5.4248 4.95215 5.4248 5.29492C5.4248 5.6377 5.70605 5.91895 6.04883 5.91895ZM6.04883 8.37109H10.707C11.0498 8.37109 11.3311 8.08984 11.3311 7.74707C11.3311 7.4043 11.0498 7.12305 10.707 7.12305H6.04883C5.70605 7.12305 5.4248 7.4043 5.4248 7.74707C5.4248 8.08984 5.70605 8.37109 6.04883 8.37109ZM3.52637 17.5293C2.58594 17.5293 2.09375 16.9932 2.09375 16.167C2.09375 15.3672 2.65625 14.8135 3.58789 14.8135H12.3594C12.4561 14.8135 12.5527 14.8047 12.6406 14.7871C12.2012 15.7188 12.2539 16.7295 12.7285 17.5293H3.52637Z" :fill="color"/>
</svg>
</template>
<script>
export default {
  name: 'PrimaryIcon',
  props: {
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 11
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
